import { notification } from 'antd';
import API from '../api/jongjonan';

/**
 * Constants
 */

export const FETCHING = 'guest/FETCHING';
export const FETCHING_OK = 'guest/FETCHING_OK';
export const FETCHING_FAILED = 'guest/FETCHING_FAILED';

export const UPDATE = 'guest/UPDATE';
export const UPDATE_OK = 'guest/UPDATE_OK';
export const UPDATE_FAILED = 'guest/UPDATE_FAILED';


/**
 * Action Creators
 */
export function fetchGuest(id) {
    return async (dispatch) => {
        try {
            dispatch({ type: FETCHING });
            const guest = await API.fetchGuest(id);
            dispatch({
                type: FETCHING_OK,
                data: guest.data
            });
        } catch (err) {
            dispatch({
                type: FETCHING_FAILED,
                err: err.response || err.message
            });
        }
    }
}

export function saveGuest(id, params) {
    return async (dispatch) => {
        try {
            dispatch({ type: UPDATE });
            const guest = await API.saveGuest(id, params);
            dispatch({
                type: UPDATE_OK,
                data: guest.data
            });
            notification.success({
                message: 'Success',
                description: 'Data berhasil disimpan',
                placement: 'bottomRight'
            });
        } catch (err) {
            dispatch({
                type: UPDATE_FAILED,
                err: err.response || err.message
            });
            notification.error({
                message: 'Error',
                description: err.message
            });
        }
    }
}

/**
 * Reducer
 */
const initialState = {
    error: false,
    isLoading: false,
    isUpdating: false,
    data: {}
};

export default function guest(state = initialState, action) {
    switch (action.type) {
        case FETCHING:
            return {
                isLoading: true,
                error: false,
                data: {}
            };
        
        case FETCHING_OK:
            return {
                isLoading: false,
                error: false,
                data: action.data
            };
        
        case FETCHING_FAILED:
            return {
                isLoading: false,
                error: action.err,
                data: {}
            };
        
        case UPDATE:
            return {
                ...state,
                isUpdating: true,
                error: false
            };
        
        case UPDATE_OK:
            return {
                ...state,
                isUpdating: false,
                data: action.data
            };
        
        case UPDATE_FAILED:
            return {
                ...state,
                isUpdating: false,
                error: true
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/modules/guest.js